import React, { FC } from "react";
import { Avatar, Upload } from "antd";
import { UploadFile } from "antd/es/upload";
import { UserOutlined, DeleteOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { TFunction } from "i18next";

interface UserImageUploadProps {
  previewSrc?: string;
  fileList: UploadFile[];
  onFileChange: (info: { fileList: UploadFile[] }) => void;
  onRemove: () => void;
  beforeUpload: () => boolean;
  t: TFunction;
}

const UserImageUpload: FC<UserImageUploadProps> = ({
  previewSrc,
  fileList,
  onFileChange,
  onRemove,
  beforeUpload,
  t,
}) => {
  const hasImage = !!previewSrc;

  return (
    <div className="flex flex-col mb-4">
      <Title level={5} className="text-[14px]">
        {t("add-user-modal.user-image")}
      </Title>

      <Avatar
        size={80}
        className="flex justify-center items-center"
        src={hasImage ? previewSrc : undefined}
        icon={!hasImage ? <UserOutlined /> : undefined}
        shape="circle"
      />

      <div className="flex flex-col gap-2 mt-3">
        <Upload
          fileList={fileList}
          onChange={onFileChange}
          onRemove={onRemove}
          beforeUpload={beforeUpload}
          accept="image/*"
          maxCount={1}
          showUploadList={false}
        >
          <button type="button" className="ant-btn ant-btn-default">
            {t("add-user-modal.select-image")}
          </button>
        </Upload>

        {hasImage && (
          <button
            type="button"
            onClick={onRemove}
            className="ant-btn ant-btn-dangerous flex items-center gap-1"
          >
            <DeleteOutlined />
            {t("add-user-modal.delete-image")}
          </button>
        )}
      </div>
    </div>
  );
};

export { UserImageUpload };
